/**
 * Helpers para colecciones de productos asignados a una entidad.
 * Funciones puras sin lógica de persistencia.
 */

/**
 * @param {Object} productos - Mapa de productos indexado por ID
 * @returns {Array} Lista con ProductoID en cada entrada
 */
export const parseAssignedProducts = (productos = {}) => {
  return Object.keys(productos).map(productId => ({
    ProductoID: productId,
    ...productos[productId],
  }))
}

/**
 * @param {Array} products - Lista de productos asignados
 * @returns {Array} Lista ordenada
 */
export const sortAssignedProducts = products => {
  return [...products].sort((a, b) => {
    const orderA = a.order != null && Number(a.order) > 0 ? Number(a.order) : null
    const orderB = b.order != null && Number(b.order) > 0 ? Number(b.order) : null

    if (orderA != null && orderB != null) return orderA - orderB
    if (orderA != null) return -1
    if (orderB != null) return 1

    const addedAtA = a.addedAt != null ? Number(a.addedAt) : null
    const addedAtB = b.addedAt != null ? Number(b.addedAt) : null

    if (addedAtA != null && addedAtB != null) return addedAtA - addedAtB
    if (addedAtA != null) return -1
    if (addedAtB != null) return 1

    return 0
  })
}

/**
 * @param {Object|Array} productos - Mapa o lista de productos asignados
 * @returns {number} Siguiente valor de order
 */
export const getNextProductOrder = (productos = {}) => {
  const products = Array.isArray(productos) ? productos : parseAssignedProducts(productos)

  if (products.length === 0) {
    return 1
  }

  const hasExplicitOrder = products.some(p => p.order != null && Number(p.order) > 0)

  if (hasExplicitOrder) {
    const maxOrder = Math.max(...products.map(p => Number(p.order) || 0))
    return maxOrder + 1
  }

  return products.length + 1
}
